import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss']
})
export class OrderConfirmationComponent implements OnInit, OnDestroy {

  private subscriptions = new Map<string, Subscription>();

  id: any;
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.subscriptions.set('routeParams',
      this.route.params.subscribe(
        (params: Params) => this.id = params.id
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }


}
